export const Logo = () => {
  return (
    <svg width="100%" viewBox="0 0 212 212" fill="none">
      <circle cx="106" cy="106" r="106" fill="url(#paint0_linear_14_33)" />
      <path d="M65.4545 87.2727V66.9091H146.364V87.2727H118.364V160H93.4545V87.2727H65.4545Z" fill="white" />
      <defs>
        <linearGradient id="paint0_linear_14_33" x1="12" y1="26.5" x2="232.5" y2="271.5" gradientUnits="userSpaceOnUse">
          <stop stop-color="#614BCE" />
          <stop offset="1" stop-color="#FD8630" />
        </linearGradient>
      </defs>
    </svg>
  )
}